<template>
  <BModal
    id="modalTambahArtikel"
    ref="modalTambahArtikel"
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
    hide-footer
    size="md"
    :title="isEdit ? 'Edit Artikel' : 'Tambah Artikel'"
    @hidden="$emit('hidden')"
  >
    <div class="px-1 py-[4px]">
      <div class="mb-1">
        <label class="text-black font-medium mb-[4px] d-block">Judul Artikel</label>
        <BFormInput
          v-model="form.judul"
          placeholder="Masukkan judul artikel"
        />
      </div>
      <div class="mb-1">
        <label class="text-black font-medium mb-[4px] d-block">Kategori</label>
        <BFormInput
          v-model="form.kategori"
          placeholder="Masukkan kategori artikel"
        />
      </div>
      <div class="d-flex justify-content-end gap-[8px] mt-2">
        <BButton
          variant="outline-primary"
          style="width: 120px"
          @click="$bvModal.hide('modalTambahArtikel')"
        >
          Batal
        </BButton>
        <BButton
          :disabled="loading"
          variant="primary"
          style="width: 120px"
          @click="onSubmit"
        >
          <BSpinner
            v-if="loading"
            small
          />
          Simpan
        </BButton>
      </div>
    </div>
  </BModal>
</template>

<script>
export default {
  name: 'ModalTambahArtikel',
  props: {
    selected: {
      type: Object,
      default: null,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['hidden', 'saved'],
  data() {
    return {
      loading: false,
      form: {
        judul: '',
        kategori: '',
      },
    }
  },
  watch: {
    selected(val) {
      if (val) {
        this.form.judul = val.judul || ''
        this.form.kategori = val.kategori || ''
      } else {
        this.form = { judul: '', kategori: '' }
      }
    },
  },
  methods: {
    show() {
      this.$refs.modalTambahArtikel.show()
    },
    async onSubmit() {
      this.loading = true
      setTimeout(() => {
        this.loading = false
        this.$bvModal.hide('modalTambahArtikel')
        this.$emit('saved')
      }, 300)
    },
  },
}
</script>
